import { createSelector } from '@reduxjs/toolkit';
import { getStore } from '../../reducers';
import { CommentState } from './model';
import { RootSelector } from '../../reducers';
import { getSelected } from '../finder/selectors';

const getComment: RootSelector<CommentState> = createSelector(getStore, (store) => store.comment);

export const getComments = createSelector(getComment, (comment) => comment.comments);
// export const getComments = createSelector(getComment, (comment) =>
//   Array(5)
//     .fill(null)
//     .map((_, index) => ({
//       id: index + 1,
//       content: 'Hello, world!',
//       author: 'Elon Musk',
//       author_id: 1,
//       created_at: '2021-01-01T00:00:00Z',
//       updated_at: '2021-01-01T00:00:00Z',
//     })),
// );

export const getInProgress = createSelector(getComment, (comment) => comment.inProgress);

export const getEditingComment = createSelector(getComment, (comment) => comment.editingComment);

export const getNewComment = createSelector(getComment, (comment) => comment.newComment);

export const getCurrentAssetId = createSelector(getSelected, (selected) =>
  selected.ids.length === 1 ? selected.ids[0] : undefined,
);
